import React from 'react';
// import PropTypes from 'prop-types';
import Layout from '../../components/layout';
import Form from '../../components/Form'
import GetImage from '../../components/Image'
import '../../styles/pages/tv-measure.css'

const propTypes = {};

const defaultProps = {};

export default class tvMeasure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Layout>
         <div class="page-wrapper">
<div class="fullscreen bg12" data-scroll-index="0">
    <div class="grediant-overlay opacity-3"></div>
    <div class="center-col white-text" id="home">
          <div class="container">
              <div class="row">
                  <div class="col-md-10 col-lg-8" data-aos="fade-up" data-aos-duration="600" data-aos-delay="500">
                      <div class="home-content">
                          <h1 class="large-heading">
                              <span class="font-weight-extralight">Do you connect TV Ads to Business outcome?</span> <br/>
                          </h1>
                      </div>
                      <div class="section-header pt-50">
                            <h4>Since not all GRPs are equal, perform tactical optimization and targeting on TV just like Digital</h4>
                        </div>
                  </div>
              </div>
          </div>
      </div>
      
</div>

   <section class="pt-100 tv-measu-what-we-do" data-scroll-index="1">
        <div class="container">
            <div class="section-header">
                <h2>What We Do</h2>
            </div>
            <div class="row">
                    <div class="col-md-3" data-aos="fade-up" data-aos-duration="300">
                            <div class="service-card border-img">
                              <div class="icon-img">
                                <i class="fa fa-search-minus fa-2x"></i>
                              </div>
                              <div class="service-body">
                                <h6 class="service-title">Spot Detection</h6>
                                <p class="service-description mt-5">Our proprietary matching technology fingerprints video content for automatic recognition of future airings
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3" data-aos="fade-up" data-aos-duration="500">
                                <div class="service-card border-img">
                                  <div class="icon-img">
                                    <i class="fa fa-wrench fa-2x"></i>
                                  </div>
                                  <div class="service-body">
                                    <h6 class="service-title">Performance Analysis </h6>
                                    <p class="service-description mt-5">Measures and analyses the impact of your TV campaigns on various digital channels: web, apps, call centers, SMS and more. We optimize your TV investments based on business and branding indicators
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-3" data-aos="fade-up" data-aos-duration="700">
                                    <div class="service-card border-img">
                                      <div class="icon-img">
                                        <i class="fa fa-database fa-2x"></i>
                                      </div>
                                      <div class="service-body">
                                        <h6 class="service-title"> TV to MultiApp </h6>
                                        <p class="service-description mt-5">83% of people use another media while in front on TV. We use this opportunity to be present on other mediums i.e. paid search, Facebook etc. when your, or even your competitor’s TV ad, is live
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3" data-aos="fade-up" data-aos-duration="900">
                                        <div class="service-card border-img">
                                          <div class="icon-img">
                                            <i class="fa fa-bullseye fa-2x"></i>
                                          </div>
                                          <div class="service-body">
                                            <h6 class="service-title">TV Audience Targeting</h6>
                                            <p class="service-description mt-5">We capitalize on TV investments by making sure you’re converting a highly engaged audience, thanks to our unique TV-visitors identification algorithm
                                            </p>
                                          </div>
                                        </div>
                                      </div>

            </div>
        </div>
    </section>

    
 

<section id="products" class="pt-50 pb-50" data-scroll-index="1" data-aos="fade" data-aos-duration="400">
        <div class="container">
            <div class="section-header">
                <h2>Why We Do</h2>
            </div>

            <div class="row">
                    <div class="col-md-4 pl-3 pr-3 product-section">
                            <div class="work-grid-box-1">
                                    <div class="grid-image grid-height-250">
                                    <GetImage filename="tv-opti.png" alt="multiple-kpi" />
                                    </div>
                                    <div class="image-box__overlay"></div>
                                    <div class="imgae-over-text">
                                        <h5 class="grid-title white-text">Multiple KPI's</h5>
                                        <p class="grid-description opacity-full">Easy tracking & optimization of digital media investments</p>
                                    </div>
                                </div>
                                <div class="product-content">
                                    <ul>
                                        <li>Visits</li>
                                        <li>Conversations</li>
                                        <li>Re-Targeting</li>
                                        <li>Sources</li>
                                        <li>ROI</li>
                                        <li>Real Time Analytics</li>
                                    </ul>
                                </div>
                    </div>
                    <div class="col-md-4 pl-3 pr-3 product-section">
                            <div class="work-grid-box-1 data">
                                    <div class="image-box__overlay"></div>
                                <div class="grid-image grid-height-225">
                                        <h4 class="text-center white-text arrow1">Digital</h4>
                                    <GetImage filename="media.png" alt="digital" />
                                    </div>
                        </div>
                        <span class="vs">VS</span>
                        <div class="work-grid-box-1 data">
                                <div class="image-box__overlay"></div>
                                    <div class="grid-image grid-height-225">
                                            <h4 class="text-center white-text arrow">Offline
                                                   
                                            </h4>
                                            <GetImage filename="tv-meau.png" alt="offline" />
                                    </div>
                        </div>
                    </div>
                <div class="col-md-4 pl-3 pr-3 product-section">
                    <div class="work-grid-box-1">
                            <div class="grid-image grid-height-250">
                            <GetImage filename="tv-meau.png" alt="offline" />
                            </div>
                            <div class="image-box__overlay"></div>
                            <div class="imgae-over-text">
                                    
                                <h5 class="grid-title white-text">Few KPI's </h5>
                                <p class="grid-description opacity-full">Some audience data but not accurate enough to optimize the TV spends</p>
                            </div>
                        </div>
                        <div class="product-content">
                            <ul>
                                <li>GRP</li>
                                <li>CPRP</li>
                                <li>Data is lagged</li>
                            </ul>
                        </div>
            </div>
                          </div>
                       </div>
    </section>


<div class="counter-section bg3 pt-50" data-scroll-index="1">
        <div class="grediant-overlay-reverse opacity-85"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-header service-2">
                        <h2 class="white-text">The Facts - New Currency To Measure TV Analytics</h2>
                    </div>
                </div>
                <div class="col-md-6 mb-30">
                    <div class="counter-box-1 service-2-content">
                        <h2 class="white-text">83%</h2>
                        <p>of people use another media in front of their TV</p>
                    </div>
                </div>
                <div class="col-md-6 mb-30">
                    <div class="counter-box-1 service-2-content">
                        <h2 class="white-text">60%</h2>
                  <p>Increase in online brand search attributed to TV Ads</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


  

 


        <section class="tv-meas-work pt-5"  data-scroll-index="1">
                <div class="container">
                    <div class="row">
                       <div class="col-md-12 col-lg-7 mb-30">
                            <div class="pt-2 text-black">
                                <h2>How It Works?</h2>
                            </div>
                       </div>
                       <div>
                       <GetImage filename="tv-meau-work.png" alt="work" />
                       </div>
                    </div>
                </div>
            </section>

   <section class="section-blog pt-100"  data-scroll-index="1">
        <div class="container">
            <div class="section-header">
                <h2>What You Get</h2>
            </div>
            <div class="row">
                <div class="col-md-4 mb-30" data-aos="fade-up" data-aos-duration="300">
                        <div class="our-step">
                                <div class="step-number text-grediant lh-n">Measure</div>
                                <p><b>Real time insights </b>for day, daypart, network, genre, program, creative and audience</p>
                            </div>
                </div>
                <div class="col-md-4 mb-30" data-aos="fade-up" data-aos-duration="400">
                        <div class="our-step">
                                <div class="step-number text-grediant lh-n">Optimize</div>
                                <p><b>Put TV analytics into action</b> using real-time performance insights and adjust ad delivery</p>
                            </div>
                </div>
                <div class="col-md-4 mb-30" data-aos="fade-up" data-aos-duration="500">
                        <div class="our-step">
                                <div class="step-number text-grediant lh-n">Target</div>
                                <p>Reach across media to augment TV audience digitally</p>
                            </div>
                </div>
            </div>
        </div>
    </section>
    <section class="contact-us-form theme-1 section-spacer" data-scroll-index="0">
        <div class="container">
            <div class="section-header">
                <h2>Get in touch</h2>
            </div>
            <Form />
        </div>
    </section>
    </div>
      </Layout>
    );
  }
}

 tvMeasure.propTypes = propTypes;
 tvMeasure.defaultProps = defaultProps;